import { helper as buildHelper } from "@ember/component/helper"

export function makeDate(params, hash) {
  return params[0] ? dateFns.parse(params[0]) : null
}

export default buildHelper(makeDate)
